export default class StaticFooter {
  constructor(section) {}
}
